<template>
  <div class="task-container">
    <div class="task-inner">
      <div class="department">
        <span @click="changeSelect('checked', false)" :class="{ active: !select.checked }">待审批</span>
        <span @click="changeSelect('checked', true)" :class="{ active: select.checked }">已审批</span>
      </div>
      <section>
        <div class="category" data-title="服务名称">
          <div>
            <span @click="changeSelect('employId')" :class="{ active: !select.employId }">全部</span>
            <span v-for="{ employId, employName, applyNumber } in serviceList" :key="employId"
              @click="changeSelect('employId', employId)" :class="{ active: employId === select.employId }">
              {{ `${employName}（${applyNumber}）` }}</span>
          </div>
        </div>
        <header>
          <el-button type="primary" @click="batchCheck" v-if="!select.checked">批量审批</el-button>
          <div class="search">
            <el-input v-model="select.userName" placeholder="请输入申请人姓名" @change="getApplyList" clearable></el-input>
            <el-date-picker v-model="select.daterange" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期"
              format="yyyy-MM-DD" value-format="yyyy-MM-DD" @change="getApplyList"></el-date-picker>
          </div>
        </header>
        <el-table :data="applyList" border ref="table" :header-cell-style="{ background: '#fff !important' }">
          <el-table-column type="selection" align="center" width="60" v-if="!select.checked"
            key="selection"></el-table-column>
          <el-table-column type="index" label="序号" align="center" width="80" key="index"></el-table-column>
          <el-table-column label="服务名称" prop="employName" align="center" key="employName"></el-table-column>
          <el-table-column label="申请人" prop="userName" align="center" key="userName"></el-table-column>
          <el-table-column label="申请时间" prop="createTime" align="center" key="createTime"></el-table-column>
          <el-table-column label="审批状态" prop="approvalStatus" align="center" v-if="select.checked" key="approvalStatus">
            <template slot-scope="{ row }">
              <b class="status"
                :style="{ '--color': ['var(--mainColor)', 'var(--successColor)', 'var(--dangerColor)', 'var(--warningColor)', 'var(--warningColor)', 'var(--dangerColor)'][row.approvalStatus - 1] }">
                {{ ['审批中', '已通过', '未通过', '已撤销 ', '挂起 ', '已结束'][row.approvalStatus - 1] }}</b>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="{ row }">
              <el-link type="primary" @click="openDialog(row)">{{ select.checked ? '详情' : '审批' }}</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="select.pageParam.current" :page-size.sync="select.pageParam.size"
          layout="total,prev,pager,next" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </section>
    </div>

    <CheckDialog ref="checkDialog" />
  </div>
</template>

<script>
import * as api from './api'
export default {
  name: 'Task',
  components: { CheckDialog: () => import('./checkDialog.vue') },
  data() {
    return {
      departmentList: [],
      categoryList: [],
      select: {
        pageParam: {
          current: 1,
          size: 10
        }
      },
      serviceList: [],
      applyList: [],
      total: 0
    }
  },
  async created() {
    const { checked } = this.$route.query
    this.select.checked = checked
    await this.getServiceList()
    this.getApplyList()
  },
  beforeUpdate() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
  methods: {
    async getServiceList() {
      this.serviceList = []
      const { data: { employList } } = this.select.checked ? await api.getDoneServiceList() : await api.getTodoServiceList()
      this.serviceList = employList
      this.select = {
        checked: this.select.checked,
        pageParam: {
          current: 1,
          size: 10
        }
      }
    },
    async getApplyList() {
      this.select.startDate = this.select.daterange ? this.select.daterange[0] : ''
      this.select.endDate = this.select.daterange ? this.select.daterange[1] : ''
      const { data: { applyList, total } } = this.select.checked ? await api.getDoneApplyList(this.select) : await api.getTodoApplyList(this.select)
      this.applyList = applyList
      this.total = total
    },
    async changeSelect(key, val) {
      this.$set(this.select, key, val)
      if (key === 'checked') {
        await this.getServiceList()
        this.getApplyList()
      }
      else this.getApplyList()
    },
    async openDialog(row) {
      const { checkDialog } = this.$refs
      const { data } = await api.getCheckedDetail(row.applyId)
      checkDialog.checkedDetail = data
      checkDialog.title = data.applyInfo.employName + '审批'
      if (!this.select.checked) checkDialog.taskId = row.taskId
      checkDialog.visible = true
    },
    batchCheck() {
      const selection = this.$refs.table.selection
      if (!selection.length) return this.$message.warning('请选择要审批的服务')
      this.$confirm('确定审批选中的服务吗？', '提示', {
        type: 'warning'
      }).then(async () => {
        await api.agreeApply({
          taskIdList: selection.map(item => item.taskId),
          comment: ''
        })
        this.$message.success('审批成功')
        this.getApplyList()
      }).catch(() => { })
    },
    handleSizeChange(val) {
      this.select.pageParam.current = 1
      this.select.pageParam.size = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.select.pageParam.current = val
      this.getTableData()
    }
  }
}
</script>

<!-- <style src="@wangeditor/editor/dist/css/style.css"></style> -->
<style lang="scss" scoped>
.task-container {
  min-height: calc(100vh - 363px);
  background: #fff;

  .task-inner {
    width: var(--inner-width);
    margin: auto;
    padding: 50px 0 100px;
    display: flex;
    gap: 40px;

    .department {
      width: 250px;

      span {
        display: block;
        height: 50px;
        background: #eee;
        color: #333;
        font-size: 14px;
        line-height: 50px;
        cursor: pointer;
        padding-left: 20px;
        border-bottom: 1px solid #fff;
        position: relative;

        &::before {
          content: '';
          width: calc(100% - 4px);
          height: 100%;
          position: absolute;
          right: 0;
          background: #fff;
          opacity: 0;
        }

        &.active {
          background: linear-gradient(to right, $mainColor, #fff);
          color: #fff;

          &::before {
            opacity: .4;
          }
        }
      }
    }

    section {
      flex: 1;

      .category {
        display: flex;
        gap: 20px;

        &::before {
          content: attr(data-title);
          color: #333;
          transform: translateY(8px);
          font-size: 18px;
        }

        div {
          flex: 1;
          display: flex;
          gap: 20px;
          flex-wrap: wrap;

          span {
            background: #eee;
            padding: 8px 20px;
            color: #888;
            border-radius: 17px;
            cursor: pointer;
            transition: 300ms ease-in-out;

            &.active {
              background: $mainColor;
              color: #fff;
            }
          }
        }
      }

      header {
        display: flex;
        margin: 40px 0 20px;

        .search {
          margin-left: auto;
          display: flex;
          gap: 10px;

          .el-input {
            width: 250px;
          }
        }
      }

      .el-table {
        margin-bottom: 20px;

        .status {
          border: 1px solid var(--color);
          font-size: 12px;
          padding: 2px 4px;
          border-radius: 2px;
          color: var(--color)
        }
      }
    }
  }
}
</style>